<script lang="ts">
    import { faSave, faRemove, faEdit, faCopy, faPaste, faPlusCircle, faTrash } from '@fortawesome/free-solid-svg-icons'
    import Zact from '../../_common/z/zact.svelte'
    import Zframe from '../../_common/z/zframe.svelte'
    import { GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Zgrid from '../../_common/z/zgrid.svelte'
    import {
        GridBadge as Grid2Badge,
        GridBadgeClassEnum as Grid2BadgeClassEnum,
        GridButton as Grid2Button,
        GridClass as Grid2Class,
        GridCol as Grid2Col,
        GridColTypeEnum as Grid2ColTypeEnum,
        GridColVisibilityEnum as Grid2ColVisibilityEnum,
        GridLine as Grid2Line,
        GridSlot as Grid2Slot,
    } from './zgrid2'
    import Zgrid2 from './zgrid2.svelte'
    import Ztab from '../../_common/z/ztab.svelte'
    import Zbutton from './zbutton.svelte'

    let tabs = [
        {
            title: 'Tab 1',
            url: '/customer-app',
        },
        {
            title: 'Tab 2',
            url: '/nps/info',
        },
    ]

    // grid
    let grid: GridClass = new GridClass()
    // grid head
    grid.title = 'Título do Grid'
    grid.subtitle = 'Grid de exemplo. Pendente acts por linha.'
    grid.cols.push(new GridCol({ content: 'Cadastro', type: GridColTypeEnum.datetime }))
    grid.cols.push(new GridCol({ content: 'Nome' }))
    grid.cols.push(new GridCol({ content: 'Telefone', type: GridColTypeEnum.phone }))
    grid.cols.push(new GridCol({ content: 'E-Mail', type: GridColTypeEnum.email }))
    grid.cols.push(new GridCol({ content: 'Nascimento', type: GridColTypeEnum.date }))
    // grid lines
    let line: GridLine = new GridLine()
    line.slots.push({ content: new Date('2023-07-30 18:45:13') })
    line.slots.push({ content: 'Cleyton Santos' })
    line.slots.push({ content: '11961504546' })
    line.slots.push({ content: 'crsantos555@gmail.com' })
    line.slots.push({ content: new Date('1982-09-29') })
    grid.lines.push(line)
    line = new GridLine()
    line.slots.push({ content: new Date() })
    line.slots.push({ content: 'Lais Tavares' })
    line.slots.push({ content: '34996432444' })
    line.slots.push({ content: 'laistavares90@gmail.com' })
    line.slots.push({ content: new Date('1990-10-19') })
    grid.lines.push(line)

    // ------------------------------------------------------------ zgrid2 (layout de contas a pagar)
    type DemoPeriod = 'month' | 'late' | 'next7' | 'all'
    type DemoBill = {
        id: string
        status: 'late' | 'open' | 'paid'
        dueDate: string
        dueHint: string
        description: string
        category: string
        recurring: boolean
        receiver: string
        method: string
        value: number
        paid: number
    }
    const demoBills: DemoBill[] = [
        { id: 'b1', status: 'late', dueDate: '2026-09-05', dueHint: '10 dias em atraso', description: 'Aluguel da unidade centro', category: 'Instalações', recurring: true, receiver: 'Imobiliária Vega', method: 'Boleto', value: 4800, paid: null },
        { id: 'b2', status: 'open', dueDate: '2026-09-16', dueHint: 'vence amanhã', description: 'Assinatura de sistema', category: 'Software', recurring: true, receiver: 'Nuvem Tech ME', method: 'Cartão', value: 120, paid: null },
        { id: 'b3', status: 'open', dueDate: '2026-09-22', dueHint: 'em 7 dias', description: 'Energia elétrica — agosto', category: 'Utilidades', recurring: true, receiver: 'Companhia de Energia', method: 'Débito automático', value: 936.45, paid: null },
        { id: 'b4', status: 'paid', dueDate: '2026-09-08', dueHint: 'pago em 08/09', description: 'Folha de pagamento', category: 'Pessoal', recurring: true, receiver: 'Equipe interna', method: 'Transferência', value: 18400, paid: 18400 },
        { id: 'b5', status: 'open', dueDate: '2026-09-28', dueHint: 'em 13 dias', description: 'Insumos de estoque', category: 'Fornecedores', recurring: false, receiver: 'Distribuidora Andrade', method: 'Pix', value: 2310.9, paid: null },
        { id: 'b6', status: 'paid', dueDate: '2026-09-03', dueHint: 'pago em 02/09', description: 'Internet dedicada', category: 'Utilidades', recurring: true, receiver: 'LinkFibra', method: 'Boleto', value: 349, paid: 349 },
        { id: 'b7', status: 'open', dueDate: '2026-10-05', dueHint: 'em 20 dias', description: 'Aluguel da unidade centro', category: 'Instalações', recurring: true, receiver: 'Imobiliária Vega', method: 'Boleto', value: 4800, paid: null },
    ]
    let demoPeriod: DemoPeriod = 'month'
    let grid2: Grid2Class = null

    function setDemoPeriod(period: DemoPeriod) {
        demoPeriod = period
        loadGrid2()
    }

    function isInDemoPeriod(bill: DemoBill): boolean {
        if (demoPeriod === 'late') return bill.status === 'late'
        if (demoPeriod === 'next7') return bill.status !== 'paid' && bill.dueDate >= '2026-09-15' && bill.dueDate <= '2026-09-22'
        if (demoPeriod === 'month') return bill.dueDate.startsWith('2026-09')
        return true
    }

    function loadGrid2() {
        const g = new Grid2Class({
            id: 'examples-bills',
            title: 'Lançamentos do período',
            totalLabel: 'Total do período',
            searchPlaceholder: 'Buscar descrição, recebedor…',
        })
        const periods: [DemoPeriod, string][] = [
            ['month', 'Este mês'],
            ['late', 'Atrasadas'],
            ['next7', 'Próximos 7 dias'],
            ['all', 'Todas'],
        ]
        g.acts = periods.map(([value, label]) => new Grid2Button({ label, active: demoPeriod === value, callback: () => setDemoPeriod(value) }))
        g.acts.push(new Grid2Button({ label: 'Nova conta', icon: faPlusCircle, color: 'green', callback: () => window.alert('Nova conta') }))

        const payMany = new Grid2Button({ label: 'Pagar selecionadas', callback: (ids: string[]) => window.alert(`Pagar: ${ids.join(', ')}`) })
        const exportMany = new Grid2Button({ label: 'Exportar', callback: (ids: string[]) => window.alert(`Exportar: ${ids.join(', ')}`) })
        g.cols.push(new Grid2Col({ type: Grid2ColTypeEnum.checkbox, bulkActions: [payMany, exportMany] }))
        g.cols.push(new Grid2Col({ content: 'Status', type: Grid2ColTypeEnum.badge }))
        g.cols.push(new Grid2Col({ content: 'Vencimento', type: Grid2ColTypeEnum.date }))
        g.cols.push(new Grid2Col({ content: 'Descrição', visibility: Grid2ColVisibilityEnum.fixed }))
        g.cols.push(new Grid2Col({ content: 'Recebedor' }))
        g.cols.push(new Grid2Col({ content: 'Forma de pagamento', visibility: Grid2ColVisibilityEnum.hidden }))
        g.cols.push(new Grid2Col({ content: 'A pagar', type: Grid2ColTypeEnum.currency, bold: true, showTotal: true }))
        g.cols.push(new Grid2Col({ content: 'Pago', type: Grid2ColTypeEnum.currency, showTotal: true, class: 'text-success' }))
        g.cols.push(new Grid2Col({ content: '', type: Grid2ColTypeEnum.button }))

        const badges = {
            late: new Grid2Badge({ label: 'atrasada', class: Grid2BadgeClassEnum.badge_danger }),
            open: new Grid2Badge({ label: 'a pagar', class: Grid2BadgeClassEnum.badge_alert }),
            paid: new Grid2Badge({ label: 'paga', class: Grid2BadgeClassEnum.badge_success }),
        }
        for (const bill of demoBills.filter(isInDemoPeriod)) {
            const btnPay = bill.status === 'paid' ? null : new Grid2Button({ label: 'Pagar', color: 'green', callback: () => window.alert(`Pagar ${bill.description}`) })
            const btnEdit = new Grid2Button({ label: 'Editar', icon: faEdit, callback: () => window.alert(`Editar ${bill.description}`) })
            const btnRemove = new Grid2Button({ label: 'Excluir', icon: faTrash, color: 'red', callback: () => window.alert(`Excluir ${bill.description}`) })
            const line = new Grid2Line()
            line.slots.push(new Grid2Slot({ content: bill.id }))
            line.slots.push(new Grid2Slot({ content: badges[bill.status] }))
            line.slots.push(new Grid2Slot({ content: bill.dueDate, subtitle: bill.dueHint, class: bill.status === 'late' ? 'text-danger' : '' }))
            line.slots.push(
                new Grid2Slot({ content: bill.description, subtitle: bill.category, badge: bill.recurring ? new Grid2Badge({ label: 'recorrente' }) : null }),
            )
            line.slots.push(new Grid2Slot({ content: bill.receiver }))
            line.slots.push(new Grid2Slot({ content: bill.method }))
            line.slots.push(new Grid2Slot({ content: bill.value }))
            line.slots.push(new Grid2Slot({ content: bill.paid }))
            line.slots.push(new Grid2Slot({ content: [btnPay, btnEdit, btnRemove] }))
            g.lines.push(line)
        }
        grid2 = g
    }
    loadGrid2()
</script>

<div class="px-5">
    <div class="mt-3 z-buttons">
        <Zbutton color="red" icon={faRemove} label="Excluir" class="me-2" />
        <Zbutton color="yellow" icon={faEdit} label="Editar" class="me-2" />
        <Zbutton color="green" icon={faSave} label="Salvar" class="me-2" />
        <Zbutton color="secondary" icon={faCopy} label="Copiar" class="me-2" />
        <Zbutton color="secondary" icon={faPaste} label="Colar" class="me-2" />
        <Zbutton color="primary" icon={faSave} label="Salvar" class="me-2" />
        <Zbutton color="primary" label="Salvar" class="me-2" />
        <Zbutton color="primary" icon={faSave} class="me-2" />
    </div>
    <Ztab class="mt-3" {tabs} />
    <Zact><button class="btn btn-primary">Botão 1</button></Zact>
    <Zframe class="mt-3" title="Configurações Gerais" headline="Configure todos os aspectos de seus recursos aqui.">
        <div>
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Alias quibusdam, dolor, cupiditate necessitatibus
            consequuntur ratione eum obcaecati reiciendis excepturi at dolore laboriosam, repellendus nesciunt molestiae
            et. Nihil molestiae blanditiis commodi!
        </div>
        <button class="btn btn-primary">Salvar</button>
    </Zframe>
    <Zgrid class="mt-3" {grid} />
    <Zgrid2 class="mt-3" grid={grid2} />
    <!-- retrocompatibilidade: o mesmo GridClass do zgrid.ts, sem mudança nenhuma, no Zgrid2 -->
    <Zgrid2 class="mt-3 mb-5" {grid} />
</div>
